import { FeatureDTO } from "./FeatureDTO";

export class QuizFeatureDTO extends FeatureDTO {
    constructor(sub?) {
        super(sub);
    }
}
